import { render, staticRenderFns } from "./AnnouncementCard.vue?vue&type=template&id=6f569dbc"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports